import React from 'react';

/**
 * SVG recreation of the MediaLabs "mh" icon mark.
 * 3 blue diagonal bars + 1 orange diagonal bar.
 */
export const MediaLabsIcon = ({ size = 32, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="MediaLabs icon"
  >
    {/* First blue bar (leftmost) */}
    <rect x="10" y="28" width="12" height="52" rx="6" fill="#1EACEE" transform="rotate(-15 10 28)" />
    {/* Second blue bar */}
    <rect x="28" y="20" width="12" height="56" rx="6" fill="#1EACEE" transform="rotate(-15 28 20)" />
    {/* Third blue bar */}
    <rect x="46" y="12" width="12" height="60" rx="6" fill="#1EACEE" transform="rotate(-15 46 12)" />
    {/* Orange bar (rightmost) */}
    <rect x="64" y="18" width="12" height="52" rx="6" fill="#F68D2C" transform="rotate(-15 64 18)" />
  </svg>
);

/**
 * Full MediaLabs logo with icon + text.
 * Uses the actual uploaded logo image.
 */
export const MediaLabsLogo = ({ height = 36, className = '', showText = true }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <img
      src="/medialabs-logo.jpg"
      alt="MediaLabs"
      style={{ height: `${height}px`, width: 'auto' }}
      className="object-contain"
    />
  </div>
);

/**
 * Small icon-only version using the image cropped to icon.
 */
export const MediaLabsIconImg = ({ size = 32, className = '' }) => (
  <img
    src="/medialabs-logo.jpg"
    alt="MediaLabs"
    style={{ height: `${size}px`, width: 'auto' }}
    className={`object-contain ${className}`}
  />
);
